export type DoseUnit = {
    id: string;
    text: string;
    system: string;
    code: string;
  }

export const DoseUnitData: DoseUnit[] = [
  { id: 'tablet', text: 'Tablet', system: 'http://unitsofmeasure.org', code: 'tablet' },
  { id: 'mg', text: 'mg', system: 'http://unitsofmeasure.org', code: 'mg' },
  { id: 'g', text: 'g', system: 'http://unitsofmeasure.org', code: 'g' },
  { id: 'microgram', text: 'microgram', system: 'http://unitsofmeasure.org', code: 'ug' },
  { id: 'ml', text: 'ml', system: 'http://unitsofmeasure.org', code: 'mL' },
  { id: 'mg/kg', text: 'mg/kg', system: 'http://unitsofmeasure.org', code: 'mg/kg'},
  { id: 'ml/kg', text: 'ml/kg', system: 'http://unitsofmeasure.org', code: 'mL/kg' },  
  { id: 'tabletCT', text: 'Tablet CT', system: 'http://snomed.info/sct', code: '428673006'},
  { id: 'sachet', text: 'sachet', system: 'http://snomed.info/sct', code: '733013000'},
  { id: 'vial', text: 'vial', system: 'http://snomed.info/sct', code: '415818006'},
  { id: 'mgCT', text: 'mg CT', system: 'http://snomed.info/sct', code: '258684004' },
  { id: 'microgramCT', text: 'microgramCT', system: 'http://snomed.info/sct', code: '258685003' },
  { id: 'gCT', text: 'g CT', system: 'http://snomed.info/sct', code: '258682000' },
  { id: 'mlCT', text: 'ml CT', system: 'http://snomed.info/sct', code: '258773002' },
  { id: 'capsule', text: 'capsule', system: 'http://snomed.info/sct', code: '428641000' },  
  { id: 'nanogram', text: 'nanogram CT', system: 'http://snomed.info/sct', code: '258686002' }, 
  { id: 'nanogram', text: 'nanogram', system: 'http://unitsofmeasure.org', code: 'ng' }, 
  { id: 'suppository', text: 'suppository', system: 'http://snomed.info/sct', code: '430293001' },
  ];